<template>
    <div>
        <!-- -->
        <el-form ref="form" :model="form" label-width="80px" class="event-form">
            <el-form-item label="下一节点" v-if="type!='transfer'&&type!='finish-observer'&&type!='reject'&&type!='cancel'&&type!='rebut'">
                <el-input v-model="handle_title" disabled></el-input>
            </el-form-item>
            <!--处理组-->
            <el-form-item label="处理组" v-if="type !='dpt-head-approved' && type!='finish-observer'&&type!='reject'&&type!='cancel'&&type!='it-head-approved'&&type!='complete'&&type!='rebut'">
                <el-select v-model="form.handle_department" filterable placeholder="请选择" @change="departmentChange">
                    <el-option v-for="item in departmentList" :key="item.index" :label="item.name"
                               :value="item.id"></el-option>
                </el-select>
<!--                <el-button :type="groupTasksTotal>=5?'danger':'success'" plain  >组繁忙度  ({{groupTasksTotal}})</el-button>-->
            </el-form-item>
            <!--处理人-->
            <el-form-item label="处理人" v-if="type !='dpt-head-approved' && type!='finish-observer'&&type!='reject'&&type!='cancel'&&type!='it-head-approved'&&type!='complete'&&type!='rebut'">
                <div class="el-form__inline">
                    <el-input v-model="currentHandlerId" disabled></el-input>
                    <el-button  type="primary" class="iconfont icon-gengduo icon" :disabled="dis_user" @click="toRequesterList"></el-button>
<!--                    <el-button type="primary" :type="userTasksTotal>=5?'danger':'success'" plain >人员繁忙度  ({{userTasksTotal}})</el-button>-->
                </div>
            </el-form-item>
            <el-form-item label="ip" v-if="resource_type =='虚拟机'&& type=='complete'">
                <el-input  v-model="form.ip"></el-input>
            </el-form-item>
            <!--处理意见-->
            <el-form-item label="备注" v-if="implementCompleted===false">
                <el-input type="textarea" v-model="form.handle_comment"></el-input>
            </el-form-item>


            <el-form-item>
                <el-button type="primary" @click="submit" :disabled="isSubmit">确定</el-button>
                <el-button type="default" @click="onCancel">取消</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>

    import common_services from "../../../services/common.service"
    import services from "../resourceApply.service"
    export default {
        props:{
            serialNumber:String,
            callback:Function,
            type:{
                type:String,
                default:""
            },
            status:String,
            resource_type:{
                type:String,
                default:""
            },
        },
        // components:{ departmentFrame },
        // components:{ notifyTab },
        data() {
            return {
                form:{
                    ip:null,
                    serial_number:'',
                    handle_department:"",
                    handle:"",
                    handler:'',
                    handle_comment:'',
                },
                currentHandlerId:'',
                isSubmit:false,
                departmentList:[],      // 处理组
                implementCompleted:false,
                currentDepartment:{},   // 选择的部门信息
                currentUserId:[],       // 选择的人员ID
                dis_user:true,
                handle_title:'',
            }
        },
        // components:{  inputFile},
        created() {
            this.getDepartment();
            // this.getUserId()
            this.form.handle = this.type
            if (this.type == "complete"){
                this.$modal.title = "创建完成"
                this.handle_title='处理完成'
            }
            if (this.type == "assessment"){
                this.$modal.title = "接收资源评估工单"
                this.handle_title='资源评估'
            }
            if (this.type == "assessment-approved"){
                this.$modal.title = "评估通过"
                this.handle_title='部门负责人审批'
            }

            if (this.type == "dpt-head-approved"){
                this.$modal.title = "部门负责人审批"
                this.handle_title='运维负责人审批'
            }
            if (this.type == "it-head-approved"){
                this.$modal.title = "运维负责人审批"
                this.handle_title='创建资源'
            }

            if(this.type=='reject'){
                this.$modal.title='拒绝'
            }
            if(this.type=='cancel'){
                this.$modal.title='取消'
            }
            if (this.type == "transfer"){
                this.$modal.title = "转交"
            }

        },
        computed:{
            dictionary(){
                return this.$store.state.dictionary;
            },
            waitApprove(){
                return this.$store.state.waitApprove;
            },
            // 知识分类id
            knowledgeType(){
                return this.$store.state.caseType.knowledge;
            },
            completionDegree(){
                return this.dictionary.completion_degree
            }
        },
        methods: {
            // getUserId(){
            //     this.form.designator=localStorage.getItem('internalUserid')
            // },
            // 服务组
            getDepartment(){
                let params= {
                    departmentId:99999,
                    type:'group'
                }
                //9999是服务组，9998是CAB小组

                common_services.getDepartmentList(params).then(res => {
                    this.departmentList = res.list;

                })

                if(JSON.stringify(this.waitApprove) !== '{}' && JSON.stringify(this.waitApprove) !== 'null' && this.type == 'assessment'){
                    this.form.handle_department =this.waitApprove.group_info.group_id
                    this.dis_user = false
                    this.getRequester({
                        name:this.waitApprove.user_info.user_name,
                        internalUserid:this.waitApprove.user_info.internal_userid

                    })
                }else{
                    this.form.handle_department =''
                    this.currentHandlerId = '';
                    this.form.handler = ''
                }
            },
            departmentChange(){
                this.dis_user = this.form.handle_department ? false : true;
                // let groupId=this.form.handle_department
                this.currentHandlerId = ''
            },
            // getGroupBusyness(id){
            //     common_services.busynessGroup(id).then(res => {
            //         this.groupTasksTotal = res.tasksTotal;
            //     }).catch(err => {
            //         this.$message.error(err.message);
            //     }).finally(() => {
            //         this.loading = false;
            //     })
            // },
            submit(){

                this.isSubmit=true
                this.form.serial_number = this.serialNumber

                console.log(this.resource_type)
                if(this.resource_type == '虚拟机' && this.type == 'complete'&& !this.form.ip &&this.type!='rebut'){
                    this.isSubmit=false
                    this.$message.error('请输入ip')
                }else if (!this.form['handle_department']&& this.type !='dpt-head-approved' && this.type!='it-head-approved' && this.type != 'complete' && this.type!='reject' && this.type!='cancel'&&this.type!='rebut') {
                    this.isSubmit=false
                    this.$message.error('请选择处理组')
                }else if(this.type!='reject'&&this.type!='cancel' && this.type !='dpt-head-approved' &&!this.currentHandlerId && this.type!='it-head-approved'&& this.type != 'complete'&&this.type!='rebut'){
                    this.isSubmit=false
                    this.$message.error('请选择处理人')
                }else{
                    // console.log(this.form)
                    services.resourceApplyHandle(this.form).then(res => {
                        this.$message.success(this.$modal.title+"成功");
                        this.close(true);
                    }).catch(err => {
                        this.isSubmit=false
                        this.$message.error(err.message);
                    })
                }

            },
            // 组员页面
            toRequesterList(){
                let id = this.form.handle_department;
                this.$router.push({
                    path: '/appointUser',
                    name: "appointUser",
                    query: {
                        callback:this.getRequester,
                        id:`${id}`,
                        exceptMe:this.exceptMe,
                        currentHandler:this.form.handler
                    }
                })
            },

            getRequester(obj){
                this.currentHandlerId = obj.name;
                this.form.handler = obj.internalUserid;
                // let userid=this.form.handler
                // this.getUserBusyness(userid)
            },
            getUserBusyness(id){
                common_services.busynessUser(id).then(res => {
                    this.userTasksTotal= res.tasksTotal;
                }).catch(err => {
                    this.$message.error(err.message);
                }).finally(() => {
                    this.loading = false;
                })
            },

            onCancel(){
                this.close();
            },
            close(refresh) {
                this.$modal.close();
                refresh && refresh === true ? this.callback() : '';
            }

        }
    }
</script>

<style lang="scss" scoped rel="stylesheet/scss">
    .noticeAdd{
        color: #1890ff;
        font-size: 27px;
        position: relative;
        top: -2px;
        margin-left: 10px;
    }
</style>
